import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../api/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  passwordMismatch: boolean;
  token: string;
  apiError: boolean = false;
  apiErrorMsg: string;

  constructor(private route: ActivatedRoute,
              private authService: AuthService,
              private router: Router
  ) { }

  ngOnInit() {
    this.route
      .params
      .map(p => p.token)
      .subscribe(token => {
        this.token = token;
      });
}

  submit(password: string, confirm: string) {
    if (password === confirm) {
      this.passwordMismatch = false;
      this.apiError = false;
      this.authService.createPassword(password, this.token).subscribe(() => {
        this.router.navigate(['/login']);
      }, error => {
        this.apiError = true;
        if (error.error.statusCode === 404) {
          this.apiErrorMsg = "User account is not valid or deleted."
        } else {
          this.apiErrorMsg = error.error.message;
        }
      });
    } else {
      this.apiError = false;
      this.passwordMismatch = true;
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/reset-password/reset-password.component.ts